import { render } from "./facturacion-pendiente.vue?vue&type=template&id=08d5aa2b&scoped=true"
import script from "./facturacion-pendiente.vue?vue&type=script&lang=js"
export * from "./facturacion-pendiente.vue?vue&type=script&lang=js"

import "./facturacion-pendiente.vue?vue&type=style&index=0&id=08d5aa2b&scoped=true&lang=css"
import "./facturacion-pendiente.vue?vue&type=style&index=1&id=08d5aa2b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d5aa2b"]])

export default __exports__